// Cliente de la búsqueda global EN VIVO (backend /api/search). Consulta toda la
// BD por sede; reemplaza el índice client-side cacheado.
import { api } from './client';
import type { SearchModule } from '../app/context/search-context';

export interface SearchResultItem {
  module: SearchModule;
  id: number | string;
  title: string;
  subtitle?: string;
  meta?: string;
  path: string;
}

export const searchGlobal = (sedeId: number | null, q: string) => {
  const qs = new URLSearchParams({ q });
  if (sedeId) qs.set('sede_id', String(sedeId));
  return api.get<{ results: SearchResultItem[] }>(`/api/search?${qs.toString()}`);
};
